export const POPULAR = 'popular';
export const NEW = 'new';
export const FREE = 'free';
export const HOMEMADE = 'hubspot';